/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Name_HelperInputs */

const en_us2_profile_editors_name_helper = /** @type {(inputs: Profile_Editors_Name_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This is what the app and your trainer call you.`)
};

const pt_br2_profile_editors_name_helper = /** @type {(inputs: Profile_Editors_Name_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É assim que o app e o seu personal te chamam.`)
};

const es_419_profile_editors_name_helper = /** @type {(inputs: Profile_Editors_Name_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Así te llaman la app y tu entrenador.`)
};

const pt_pt2_profile_editors_name_helper = /** @type {(inputs: Profile_Editors_Name_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É assim que a app e o teu treinador te tratam.`)
};

const fr_fr2_profile_editors_name_helper = /** @type {(inputs: Profile_Editors_Name_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'est ainsi que l'app et ton coach t'appellent.`)
};

const de_de2_profile_editors_name_helper = /** @type {(inputs: Profile_Editors_Name_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`So nennen dich die App und dein Coach.`)
};

const it_it2_profile_editors_name_helper = /** @type {(inputs: Profile_Editors_Name_HelperInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È così che ti chiamano l'app e il tuo coach.`)
};

/**
* | output |
* | --- |
* | "This is what the app and your trainer call you." |
*
* @param {Profile_Editors_Name_HelperInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_name_helper = /** @type {((inputs?: Profile_Editors_Name_HelperInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Name_HelperInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_name_helper(inputs)
	if (locale === "es-419") return es_419_profile_editors_name_helper(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_name_helper(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_name_helper(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_name_helper(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_name_helper(inputs)
	return en_us2_profile_editors_name_helper(inputs)
});
export { profile_editors_name_helper as "profile-editors.name_helper" }